import mainLogo1 from './../../../img/logo_main_1.png';

import './BrandLogo.scss';

const BrandLogo = () => (<img className="brand-logo" src={mainLogo1} alt='логотип'></img>)

export default BrandLogo;